import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'fms-button',
	templateUrl: 'button.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class ButtonComponent {
	@Input() disabled = false;
	@Input() type: 'default' | 'secondary' | 'primary' = 'default';
}
